import React, {useState} from "react";
import {
    Button,
    checkAndSetError,
    clearInputFormErrorFields,
    convertInputFormToObject,
    InputForm,
    inputFormIsValid,
    NumberField,
    SelectField,
    TextField,
    useInputForm,
} from "../../Components/Inputs";
import {GridCell, gridConstants} from "../../Components/Grid";
import {sortArrayOfObjectsByProperty} from "../../Utilities/Types/arrayUtilities";
import {LibraryItemCopy} from "./LibraryItemCopy";

import type {ListItem} from "../../Utilities/Types/listUtilities";

interface LibraryItemFormatViewProps {
    handleBarcode: (copyId: string) => void;
    handleReturn: () => void;
    handleSaveResource: (data: Record<string, unknown>) => void;
    format: Record<string, any>;
    title?: string;
    vendors: ListItem[];
}

export const LibraryItemFormatView = ({
                                          handleBarcode,
                                          handleReturn,
                                          handleSaveResource,
                                          format,
                                          title,
                                          vendors,
                                      }: LibraryItemFormatViewProps) => {

    const formatForm = useInputForm(format);
    const [editCopyId, setEditCopyId] = useState("");
    const isEditing = !!editCopyId;

    const handleDone = (data: Record<string, unknown>) => {

        let updatedCopies = [...(formatForm.copies.value as unknown as Record<string, unknown>[])]
            .filter((c: Record<string, unknown>) => c.copyId !== data.copyId);
        updatedCopies.push(data);

        updatedCopies = sortArrayOfObjectsByProperty(updatedCopies, "copyNumber" as keyof Record<string, unknown> & string);
        formatForm.copies.setValue(updatedCopies as unknown as string);

        setEditCopyId("");
    }

    const handleSubmitClick = () => {
        clearInputFormErrorFields(formatForm);

        checkAndSetError([
            formatForm.numberOfVolumes,
        ]);

        if (inputFormIsValid(formatForm)) {
            const dirtyResource = convertInputFormToObject(formatForm);
            handleSaveResource(dirtyResource);
        }
    }

    return <>
        <InputForm name={`formatForm`}>
            <TextField disabled label={"Title"} medium_columns={gridConstants.column.SIX} name={"title"}
                       value={title}/>
            <TextField disabled label={`Format`} medium_columns={gridConstants.column.SIX} name={"Format"}
                       value={format.formatName}/>

            <SelectField {...formatForm.vendorId} medium_columns={gridConstants.column.SIX} label={`Vendor`}
                         options={vendors}/>
            <NumberField {...formatForm.cost} isPositiveNumberOnly medium_columns={gridConstants.column.SIX}/>

            <hr/>
            <NumberField {...formatForm.numberOfCopiesToAdd} isPositiveNumberOnly isWholeNumberOnly
                         label={`Order Copies`}
                         helpText={`After save, new orders will show on Order Management screen.`}
                         medium_columns={gridConstants.column.SIX}/>

            <LibraryItemCopy
                editCopyId={editCopyId}
                handleBarcode={handleBarcode}
                handleDone={handleDone}
                isEditing={isEditing}
                itemForm={formatForm}
                setEditCopyId={setEditCopyId}
            />

            <hr/>
            <GridCell className={`text-center`}>
                <Button disabled={isEditing} isPrimary isCollapsed label={'Save'} name={`btnSubmit`}
                        onClick={handleSubmitClick}/>
                <Button disabled={isEditing} isCollapsed label={'Cancel'} name={`btnCancel`} onClick={handleReturn}/>
            </GridCell>
        </InputForm>
    </>;
};

